import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSummaryCardComponent } from '../app-summary-card/app-summary-card.component';
import { TeamDensityCardComponent } from '../team-density-card/team-density-card.component';
import { RecentActivityCardComponent } from '../recent-activity-card/recent-activity-card.component';
import { ApplicationsService } from '../../features/apps/services/apps.service';
import { AppForm } from '../../features/apps/models/app.model';
import { UICardModule } from '@homepower-co/shared-ui-angular';

@Component({
  selector: 'app-dashboard-cards',
  standalone: true,
  imports: [
    CommonModule,
    AppSummaryCardComponent,
    TeamDensityCardComponent,
    RecentActivityCardComponent,
    UICardModule,
  ],
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
})
export class DashboardCardsComponent implements OnInit {
  apps: AppForm[] = [];

  frontend = 35;
  backend = 42;
  transversal = 12;
  design = 11;

  newUsers = 2;
  modifiedRoles = 2;
  newApps = 1;

  private appsService = inject(ApplicationsService);

  ngOnInit() {
    this.loadApplications();
  }

  loadApplications() {
    this.appsService.getApplications().subscribe({
      next: (apps) => {
        this.apps = apps || [];
      },
      error: (err) => console.error('Error loading apps for card', err),
    });
  }
}
